function formatDate(date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
  return fmt;
};

export function fullDate(dateText) {
  if(!dateText) {
    return '';
  }
  return formatDate(new Date(dateText), 'yyyy-MM-dd hh:mm:ss');
}

export function baseDate(dateText) {
  return formatDate(new Date(dateText), 'yyyy-MM-dd');
}
// 码值翻译为汉字
export function translation (value, arr, itemNo, itemName) {
  if (!arr) {return; }
  const code = itemNo ? itemNo : 'key';
  const name = itemName ? itemName : 'name';
  return arr.find(item => String(item[code]) === String(value)) && arr.find(item => String(item[code]) === String(value))[name];
}
// 列表展示
export function listShow(list) {
  if (list && list.length) {
    return list.join('，');
  } else {
    return '';
  }
}
// 字典表翻译
export function dicTranslateFun(showValue, list, label = 'label', value = 'value') {
  if (String(showValue)) {
    let valueList = [];
    if (Object.prototype.toString.call(showValue) === '[object Array]') {
      valueList = showValue;
    } else if (Object.prototype.toString.call(showValue) === '[object Boolean]'
    || Object.prototype.toString.call(showValue) === '[object String]') {
      valueList = [showValue];
    } else {
      valueList = [String(showValue)];
    }
    return list.filter(item => valueList.includes(item[value])).map(item => item[label]).join(',');
  } else {
    return '';
  }
}

